import withStore, { TLoadingAwarePresenter, TPresentable } from "../withStore";
import Application from "../../Application";
import ShowErrorMessageInteractor from "../../interactor/notifications/ShowErrorMessageInteractor";
import { IRequestType } from "../../model/request/RequestType";
import GetRequestTypesInteractor from "../../interactor/requests/GetRequestTypesInteractor";
import CreateRequestTypeInteractor from "../../interactor/requests/CreateRequestTypeInteractor";
import ShowSuccessMessageInteractor from "../../interactor/notifications/ShowSuccessMessageInteractor";
import UpdateRequestTypeInteractor from "../../interactor/requests/UpdateRequestTypeInteractor";

export interface TRequestTypesPresenter extends TLoadingAwarePresenter {
  requestTypes: IRequestType[] | undefined;
}
export interface IRequestTypesPresenter
  extends TRequestTypesPresenter,
    TPresentable {
  getRequestTypes(): Promise<void>;
  setRequestTypes(requestTypes: IRequestType[]): void;
  createRequestType(requestType: IRequestType): void;
  updateRequestType(requestType: IRequestType): void;
}

const defaultState: TRequestTypesPresenter = {
  requestTypes: []
};

const RequestTypesPresenter = withStore<
  IRequestTypesPresenter,
  TRequestTypesPresenter
>(({ application, store, loader, translate }): IRequestTypesPresenter => {
  const _store = store;
  const _application: Application = application;
  const state = _store.getState<TRequestTypesPresenter>();

  const setRequestTypes = (requestTypes: IRequestType[]) => {
    _store.update({ requestTypes: requestTypes });
  };

  const getRequestTypes = async () => {
    try {
      let requestTypes = await _application.container
        .resolve<GetRequestTypesInteractor>("getRequestTypes")
        .execute();
      _store.update({ requestTypes });
    } catch (error) {
      _application.container
        .resolve<ShowErrorMessageInteractor>("showErrorMessage")
        .execute((error as any).message);
    }
  };

  const createRequestType = async (requestType: IRequestType) => {
    try {
      await _application.container
        .resolve<CreateRequestTypeInteractor>("createRequestType")
        .execute(requestType);
      _application.container
        .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
        .execute(
          translate("requestTypes_page.messages.create_requestType_success")
        );
      await getRequestTypes();
    } catch (error) {
      _application.container
        .resolve<ShowErrorMessageInteractor>("showErrorMessage")
        .execute((error as any).message);
    }
  };

  const updateRequestType = async (requestType: IRequestType) => {
    try {
      await _application.container
        .resolve<UpdateRequestTypeInteractor>("updateRequestType")
        .execute(requestType);
      _application.container
        .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
        .execute(
          translate("requestTypes_page.messages.update_requestType_success")
        );
      await getRequestTypes();
    } catch (error) {
      _application.container
        .resolve<ShowErrorMessageInteractor>("showErrorMessage")
        .execute((error as any).message);
    }
  };

  return {
    ...state,

    store: _store,
    loader,
    application: _application,
    translate,
    getRequestTypes,
    setRequestTypes,
    createRequestType,
    updateRequestType
  };
}, defaultState);

export default RequestTypesPresenter;
